import React, { useEffect, useState } from "react";
import { IonToast } from "@ionic/react";
import {
  carrierMcNo,
  carrierUsDotNo,
  Roles,
  RoleUpdate_Alert,
  REGISTER_MOBILE_NUMBER_ALREADY_EXIST_MESSAGE
} from "../../utils/constants";
import RegisterComponent from "../../pages/Registration/Registration.page";
import { clear, GPSWrapper, IONICWrapper, isMobile, navigate, validatePhoneNumberFormat } from "../../utils/common";
import { UserDetails } from "../../models/userProfile/userProfile.modal";
import i18n from "../../../i18n";
import { logEvent, setScreenName } from "../../utils/Analytics";
import { EVENT, SCREEN } from "../../utils/constants.analytics";
import { getUserRole } from "../../utils/UserDetails.util";
import { useAuthService } from "../../services/Auth";
import { LogIn } from "../../models/home/login.model";
import {
  getSelectedRoles,
  removeSpecial,
  getRequestedRoles
} from "../../pages/Manage/ManageUser/ManageUserUtil";
import { Alert } from "../../components/Alert/Alert";
import { useDispatch } from "react-redux";
import { checkMobileNumberExist } from "../../actions/App/action";
import { CustomModal } from "../../components/CustomModal";
import { CustomModalWeb } from "../../web/pages/userProfile/CustomModalWeb";
import { useTranslation } from "react-i18next";

export const RegisterContainer: React.FC = (props: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userExtMsg =
    (IONICWrapper.details.keys?.configuration
        .mobileNumberAlreadyExxistMessage) ||
    REGISTER_MOBILE_NUMBER_ALREADY_EXIST_MESSAGE;
  const [showCarrierAlert, setShowCarrierAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [roleUpdated, setRoleUpdate] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [mobileValidateError, setMobileValidateError] = useState(false);
  const [userEsistanceErrorProps, setUserEsistanceErrorProps] = useState<any>(
    null
  );
  const [isMFA, setIsMFA] = useState(false);
  const submitFormWithoutMobileNumberValidation = (state: any) => {
    const mobileNumber =
      state?.mobileNumber;
    const mobileNumberWithCountryCode: string = mobileNumber && state?.countryCode?.concat(mobileNumber);
    const userInput = {
      firstName: state.firstName,
      lastName: state.lastName,
      mobileNumber: mobileNumberWithCountryCode,
      companyName: state.companyName,
      corporateZipCode: state.corporateZipCode,
      carrierUsDotNo: state.slectedNo === carrierUsDotNo ? state.USDOTNO : null,
      carrierMcNo: state.slectedNo === carrierMcNo ? state.USDOTNO : null,
      role: getSelectedRoles(state.role),
      tractorNumber: state.isDriverSelected ? state.tractorNumber : null,
      addressDTOs: state.isDriverSelected ? state.addressDTOs : null,
      requestedRoles: getRequestedRoles(state.role) && getRequestedRoles(state.role).toString()
    };

    if (
      state.firstName.length > 0 &&
      state.lastName.length > 0 &&
      state.companyName.length > 0 &&
      state.mobileNumber.length > 0 &&
      state.corporateZipCode.length > 0 &&
      state.USDOTNO.length > 0 &&
      state.roleError === "" &&
      state.mobileNumberError === "" &&
      state.zipcodeEror === "" &&
      state.usDotError === ""
    ) {
      registerUser(userInput);
    }

  };

   // Regarding Defect DE15972
  // const submitForm = (state: any) => {
  //   const mobileNumber =
  //     state?.mobileNumber;
  //   const mobileNumberWithCountryCode: string = mobileNumber && state?.countryCode?.concat(mobileNumber);
  //   if (mobileNumber?.length === 12) {
  //     const _model: UserDetails = new UserDetails();
  //     const query = _model.validateUser(validatePhoneNumberFormat(mobileNumberWithCountryCode));
  //     const callback = (responseType: string, data?: any) => {
  //       if (responseType === "FAILURE") {
  //         logEvent(EVENT.UE_REGISTER_NOW, {
  //           screen: SCREEN.REGISTRATION
  //         });
  //         const userInput = {
  //           firstName: state.firstName,
  //           lastName: state.lastName,
  //           mobileNumber:mobileNumberWithCountryCode,
  //           companyName: state.companyName,
  //           corporateZipCode: state.corporateZipCode,
  //           carrierUsDotNo:state.slectedNo === carrierUsDotNo ? state.USDOTNO : null,
  //           carrierMcNo: state.slectedNo === carrierMcNo ? state.USDOTNO : null,
  //           role: getSelectedRoles(state.role),
  //           tractorNumber: state.isDriverSelected ? state.tractorNumber : null,
  //           addressDTOs: state.isDriverSelected ? state.addressDTOs : null,
  //           requestedRoles:getRequestedRoles(state.role) && getRequestedRoles(state.role).toString()
  //         };
  //         if (
  //           state.firstName.length > 0 &&
  //           state.lastName.length > 0 &&
  //           state.companyName.length > 0 &&
  //           state.mobileNumber.length > 0 &&
  //           state.corporateZipCode.length > 0 &&
  //           state.USDOTNO.length > 0 &&
  //           state.roleError === "" &&
  //           state.mobileNumberError === "" &&
  //           state.zipcodeEror === "" &&
  //           state.usDotError === ""
  //         ) {
  //           registerUser(userInput);
  //         }
  //       } else if (responseType === "SUCCESS") {
  //         let temp: any = {
  //           size: `small ${isMobile ? "" : "extra_small_height"}`,
  //           title: t("Existing User"),
  //           message: userExtMsg
  //         };
  //         if (isMobile) {
  //           temp.isOpen = true;
  //           temp.buttons = [
  //             {
  //               label: t("Ok"),
  //               type: "primary-cta-btn-mobile",
  //               callback: async () => {
  //                 setUserEsistanceErrorProps({ isOpen: false });
  //               }
  //             }
  //           ];
  //         } else {
  //           temp.isModalOpen = true;
  //           temp.buttons = [
  //             {
  //               title: t("Ok"),
  //               type: "primary-cta-btn-web",
  //               onClick: () => {
  //                 setUserEsistanceErrorProps({ isisModalOpenOpen: false });
  //               }
  //             }
  //           ];
  //         }
  //         setUserEsistanceErrorProps(temp);
  //       }
  //     };
  //     dispatch(checkMobileNumberExist({ query, callback }));
  //   }
  //   else
  //   {
  //     setMobileValidateError(true);
  //   }
  //   // Analytics implementation
  // };
  const registerUser = (userInput: any) => {
    props.setDriverOnlySelected(
      (userInput?.role &&
        userInput.role.length === 1 &&
        userInput.role[0].value === Roles.carrierDriver) ||
        false
    );
    const _model: UserDetails = new UserDetails();
    const { userDetails = {} } = props;
    const token =
      (IONICWrapper.details.auth?.tokens.access_token) ||
      "";
    const requestPayload = {
      email: userDetails?.memberDetailsResponse?.member?.upn,
      firstName: userInput.firstName,
      lastName: userInput.lastName,
      mobileNumber: validatePhoneNumberFormat(userInput.mobileNumber),
      companyName: userInput.companyName,
      corporateZipCode: userInput.corporateZipCode,
      carrierUsDotNo: userInput.carrierUsDotNo,
      carrierMcNo: userInput.carrierMcNo,
      roles: userInput.role,
      upn: userDetails?.memberDetailsResponse?.member?.upn,
      tractorNumber: userInput.tractorNumber,
      addressDTOs: userInput.addressDTOs,
      requestedRoles:userInput.requestedRoles
    };
    props.registerUser(token, _model.registerMember(requestPayload));
  };

  useEffect(() => {
    if (props?.userDetails && Object.keys(props.userDetails).length) {
      const role = getUserRole(props);
      const { status, message } = props.getRegisterUserStatus;
      const carrierId = getCarrierIdDetails(props);
      setPhoneNumber(props.userDetails?.memberDetailsResponse?.member?.mobileNumber);
      props.userDetails?.memberDetailsResponse?.member?.mobileNumber?.slice(-10)?.length === 10 ? setIsMFA(true) : setIsMFA(false);
      setUserDetailsData(
        status,
        carrierId,
        props,
        setShowCarrierAlert,
        setMessage,
        role,
        setRoleUpdate
      );
      if (!status && message) {
        setShowErrorToast(!status);
        setMessage(message);
      }
      // Analytics implementation for successful/failed registration
      setScreenName("screen_register_container");
      logEvent(
        status
          ? IONICWrapper.details.auth.user.roles.includes(Roles.carrierGuest)
            ? EVENT.UE_GUEST_REGISTER_SUCCESS
            : EVENT.UE_REGISTER_SUCCESS
          : IONICWrapper.details.auth.user.roles.includes(Roles.carrierGuest)
          ? EVENT.UE_GUEST_REGISTER_FAILURE
          : EVENT.UE_REGISTER_FAILURE,
        {
          screen: SCREEN.REGISTRATION
        }
      );
    }
  }, [props.userDetails, props.getRegisterUserStatus]);
  const authService = useAuthService();
  const azureLogout = async () => {
    props.setMemberApiError();
    if (props.isCapacitor) {
      GPSWrapper.details.stopGPS();
    }
    await clear();
    await authService.logout();
    const _clear = new LogIn();
    _clear.clearToken();
    props.logout();
  };
  return (
    <>
      <Alert
        isOpen={roleUpdated}
        message={RoleUpdate_Alert.message}
        mode="ios"
        title={RoleUpdate_Alert.header}
        cssClass="roleupdate-alert register"
        buttons={[
          {
            text: RoleUpdate_Alert.ignore_btn,
            role: "cancel",
            cssClass: "secondary-cta-btn-mobile",
            handler: () => {
              setRoleUpdate(false);
              props.setUserState(true);
              props.clearRegisterUserStatus();
            }
          },
          {
            text: RoleUpdate_Alert.logout_btn,
            role: "ok",
            cssClass: "primary-cta-btn-mobile",
            handler: async () => {
              azureLogout();
              setRoleUpdate(false);
              props.clearRegisterUserStatus();
            }
          }
        ]}
      />
      <Alert
        isOpen={showCarrierAlert}
        message={message}
        title="New Carrier"
        mode="ios"
        cssClass="carrier-alert register"
        buttons={[
          {
            text: "No",
            role: "cancel",
            cssClass: "secondary-cta-btn-mobile",
            handler: () => {
              props.setUserState(true);
              setShowCarrierAlert(false);
              props.clearRegisterUserStatus();
            }
          },
          {
            text: "Yes",
            role: "ok",
            cssClass: "primary-cta-btn-mobile",
            handler: () => {
              navigate();
              setShowCarrierAlert(false);
              props.setUserState(true);
              props.clearRegisterUserStatus();
            }
          }
        ]}
      />
      <IonToast
        isOpen={showErrorToast}
        message={message}
        duration={5000}
        color="dark"
        onDidDismiss={() => {
          props.clearRegisterUserStatus();
          setShowErrorToast(false);
        }}
      />
      <RegisterComponent
        submitForm={submitFormWithoutMobileNumberValidation}
        showAlert={props.showNetworkAlert}
        isNetworkAvailable={props.isNetworkAvailable}
        phoneNumber={phoneNumber}
        mobileValidateError={mobileValidateError}
        setMobileValidateError={setMobileValidateError}
        dispatch={dispatch}
        isMFA={isMFA}
      />
      {isMobile ? (
        <CustomModal {...userEsistanceErrorProps} />
      ) : (
        <CustomModalWeb {...userEsistanceErrorProps} />
      )}
    </>
  );
};

const getCarrierIdDetails = (props: any) => {
  return props.userDetails?.memberDetailsResponse?.member?.carrierId;
};
const setUserDetailsData = (
  status: any,
  carrierId: any,
  props: any,
  setShowCarrierAlert: React.Dispatch<React.SetStateAction<boolean>>,
  setMessage: React.Dispatch<React.SetStateAction<string>>,
  role: any,
  setRoleUpdate: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (status && !carrierId) {
    if (!props.driverOnlySelected) {
      props.setUserState(false);
      setShowCarrierAlert(status);
      setMessage(i18n.t("New_Carrier_Message"));
    } else {
      props.setUserState(true);
    }
  } else if (status) {
    if (!IONICWrapper.details.auth.user.roles.includes(role)) {
      setRoleUpdate(true);
      props.setUserState(false);
    } else {
      setRoleUpdate(false);
    }
  }
};
